module.exports = __webpack_public_path__ + "static/media/golf6.aa4045ec.jpg";